/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// @ts-nocheck
import React, { useRef } from 'react';
import styled from 'styled-components';
import { IconButton, Headline } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import {
  SYS_PAGE_MARGIN,
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_RELATIVE_SM,
} from '@oneaudi/unified-web-common';
import mapContext from '../../../contexts/map-context';
import { messages } from '../../../i18n/messages';
import { CenterPanel } from './CenterPanel';
import { LegalDisclaimer } from '../../common/LegalDisclaimer/LegalDisclaimer';
import { CustomerReviewList } from './CustomerReviewList';
import { ServiceSelectionBar } from './ServiceSelectionBar';
import { RatingBreakdown } from './RatingBreakdown';
import { FilterSortBar } from './FilterSortBar';
import type { UnifiedTheme } from '../../../FeatureApp';

export const DesktopFlyout = () => {
  const { ratingSummary, dealerReviews, showComments } = mapContext.useMapState();

  const containerRef = useRef<HTMLDialogElement | null>(null);
  const closeRef = useRef<HTMLDivElement>(null);
  const heading = useRef<HTMLDivElement>(null);

  const ratingLabel = useI18n(messages.five_star_ratings);

  const closeModal = () => {
    const backdrop = document.getElementById('fiveStarFlyoutBackdrop');
    const dialog = document.getElementById('fiveStarFlyout') as HTMLDialogElement;
    dialog.style.visibility = 'hidden';
    if (backdrop) backdrop.style.display = 'none';
    dialog.close();
  };

  const totalRatings = ratingSummary?.totalRatings ?? 0;

  return (
    <>
      <Backdrop id="fiveStarFlyoutBackdrop" />
      <DesktopFlyoutContainer
        ref={containerRef}
        id="fiveStarFlyout"
        showComments={showComments}
        data-testid="desktop-flyout-component"
      >
        <CloseButton
          ref={closeRef}
          variant="tertiary"
          icon="cancel"
          size={'xs' as any}
          onClick={closeModal}
        />

        <Header ref={heading}>
          <SubHeader>
            <RatingsText tag="span" variant={{ order: '3', type: 'headline', weight: 'normal' }}>
              {totalRatings} {ratingLabel}
            </RatingsText>
            <LegalDisclaimer />
          </SubHeader>
        </Header>
        <RatingPanel>
          <CenterPanel />
          <RatingBreakdown />
        </RatingPanel>
        {showComments && dealerReviews && dealerReviews.length > 0 && (
          <>
            <ServiceSelectionBar />
            <FilterSortBar />
          </>
        )}
        {showComments && (
          <BodyContainer isLegacy={process.env.IS_LEGACY}>
            <CustomerReviewList />
          </BodyContainer>
        )}
      </DesktopFlyoutContainer>
    </>
  );
};
const isLegacy = process.env.IS_LEGACY;
const DesktopFlyoutContainer = styled.dialog.attrs({
  'data-test-id': 'desktop-flyout-component',
})<{ showComments: boolean }>`
  background: ${(props: UnifiedTheme) =>
    !isLegacy ? '#2A313C' : props.theme.sys.color.canvas.default};
  border-radius: ${!isLegacy && '20px'};
  border: 0px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  ${(props: { showComments?: boolean }) =>
    props.showComments
      ? ` left: 100%;
  margin: 0;`
      : ` margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);`}

  max-height: calc(100vh - 72px);
  padding: ${SYS_PAGE_MARGIN};
  position: absolute;
  visibility: hidden;
  width: 768px;
  z-index: 9999;
`;

const Backdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  display: none;
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 9998;
`;

const Header = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: auto min-content;
  justify-content: space-between;
  margin: 0 0 ${SYS_SPACE_FIXED_100};
`;

const BodyContainer = styled.div<{ isLegacy: string | undefined }>`
  box-sizing: border-box;
  overflow: auto;
  scrollbar-color: rgba(0, 0, 0, 0.4) transparent; /* optional for FF */
  scrollbar-width: thin; /* Firefox */

  /* For WebKit browsers (Chrome, Edge, Safari) */
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  padding: ${SYS_SPACE_FIXED_200};
`;

const CloseButton = styled(IconButton)`
  padding: 0;
  position: absolute;
  right: ${SYS_SPACE_FIXED_100};
  top: ${SYS_SPACE_FIXED_100};
`;

const RatingPanel = styled.div`
  column-gap: 39.5px;
  display: grid;
  grid-template-columns: 0.7fr 1fr;
  margin: ${SYS_SPACE_RELATIVE_SM} 0;
`;

const SubHeader = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: auto min-content;
`;

const RatingsText = styled(Headline)`
  font-size: 18px;
`;
